module.exports = __webpack_public_path__ + "a17b7ad9eaa85411a1e1f8b05ffe4681.svg";